import type { TFunction } from 'i18next';

/** Who gets a gate's decision email — a literal switch, since the i18n guard rejects variables. */
export const decisionRecipientLabel = (t: TFunction, value: string): string => {
  switch (value) {
    case 'assignee':
      return t('Ticket assignee');
    case 'reporter':
      return t('Request reporter');
    case 'group_members':
      return t('Group members');
    default:
      return value;
  }
};
